"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
function useStrict(strictMode) {
    mobx_1.configure({ enforceActions: strictMode ? 'observed' : 'never' });
}
exports.default = useStrict;
